module.exports = {"150125100":"可可以力更镇","150125101":"哈乐镇","150125102":"西乌兰不浪镇","150125200":"大青山乡","150125205":"上秃亥乡","150125207":"得胜沟乡","150125211":"二份子乡","150125213":"哈拉合少乡","150125214":"耗赖山乡","150125402":"内蒙古武川经济开发区","150125403":"武川金三角经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150125.json
// module id = 487
// module chunks = 0